import React, { Fragment,memo } from 'react';
//Views
import CreateEditOfflineDevice from '../../../../../offlineDevice/createEdit';
import CreateEditChart from '../../../../../chart/createEdit';
import RecentAlerts from '../../../../../recentAlerts/createEdit';
import LandmarkVisit from '../../../../../landmarkVisit/createEdit';
import LandmarkRealTime from '../../../../../landmarkRealTime/createEdit';
import EmissionCheck from '../../../../../EmissionCheck/createEdit';



const renderComponent = (props) => {

    const { selectGadget, onSubmit, handleClose } = props;

    switch (selectGadget.type) {
        default:
        case 'OfflineDevices':
            return (
                <CreateEditOfflineDevice onSubmit={onSubmit} handleClose={handleClose} />
            );
        case 'Chart':
            return (
                <CreateEditChart onSubmit={onSubmit} handleClose={handleClose} />
            );
        case 'RecentAlerts':
            return (
                <RecentAlerts onSubmit={onSubmit} handleClose={handleClose} />
            );
        case 'LandmarkVisit':
            return (
                <LandmarkVisit onSubmit={onSubmit} handleClose={handleClose} />
            );
        case 'LandmarkRealTime':
            return (
                <LandmarkRealTime onSubmit={onSubmit} handleClose={handleClose} />
            );
        case 'EmissionCheck':
            return (
                <EmissionCheck onSubmit={onSubmit} handleClose={handleClose} />
            );
    }
};

const CreateEditGadgets = (props) => {


    return (
        <Fragment>
            {(
                renderComponent(props)
            )}
        </Fragment>
    );

}

export default memo(CreateEditGadgets);
